import { User } from '../user/types'
import { Classified } from '~/models/classified/types'
import { Pagination } from '~/models/search/types'

export interface ClassifiedList {
  name: string
  description: string
  classifiedsCount: number
  created: Date
  publicId: string
  shareUrl: string
  user: User
  isReadonly: boolean
  isFavorite: boolean
  isClassifiedInList: boolean
  commentingEnabled: boolean
  reactionsEnabled: boolean
  classifieds: { pagination: Pagination; rows: Classified[] }
}

export enum ReactionEnum {
  LOVE = 'love',
  SARCASTIC = 'sarcastic',
  MONEY = 'money',
  WINK = 'wink',
  LAUGHING = 'laughing',
  LIKE = 'like',
  DISLIKE = 'dislike'
}
